import { createSlice } from "@reduxjs/toolkit";
import { fetchSellersThunk } from "./sellersThunk";

const initialState = {
    items: [],
    total: 0,
    totalPages: 0,
    loading: false,
    hasMore: true,
    error: null,
    page: 1,
    counts: {
        pending: 0,
        approve: 0,
        decline: 0
    }
};

export const sellerSlice = createSlice({
    name: "sellers",
    initialState,
    reducers: {
        setPage: (state, action) => {
            state.page = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSellersThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSellersThunk.fulfilled, (state, action) => {
                state.loading = false;
                const data = action.payload;
                state.items = data.content;
                state.total = data.totalElements;
                state.totalPages = data.totalPages;
                state.hasMore = !data.last;
                state.counts = data.counts;
            })
            .addCase(fetchSellersThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setPage } = sellerSlice.actions;
export default sellerSlice.reducer;
